<template>
  <!-- TODO: this should be component - 'FillableCell' -->
  <div
    class="fillable-cell-component-container"
    :style="`
      height: ${height || 32}px;
      width: ${ width || 128}px;
      justify-content: ${flex_align_horizontal || 'center'};
      align-items: ${flex_align_vertical || 'center'};
      ${is_no_shrink ? 'flex-shrink:0;' : ''}
    `"
  >
    <slot name="content"/>
  </div>
</template>

<script>

  export default {
    components: {

    },

    props: [
      'height',
      'width',
      'flex_align_vertical',
      'flex_align_horizontal',
      'is_no_shrink',
    ],
  }
</script>

<style>
.fillable-cell-component-container {
  display: flex;
}
</style>
